import portalApi from './portalApi';

const portalProfileService = {
  getProfile: () => portalApi.get('/portal/profile'),
  updateProfile: (data) => portalApi.put('/portal/profile', data),
  changePassword: (data) => portalApi.post('/portal/profile/change-password', data),
  updateNotifications: (data) => portalApi.put('/portal/profile/notifications', data),
};

export default portalProfileService;
